(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SendLabCompendium', SendLabCompendium);

    SendLabCompendium.$inject = ['$resource'];

    function SendLabCompendium ($resource) {
        var resourceUrl =  'api/send-lab-compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': { url: 'api/send-lab-compendiums/filter', method: 'GET', isArray: true}
        });
    }
})();
